var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2198 4.37713C17.5638 4.68289 17.5948 5.20962 17.289 5.5536L8.40013 15.5536C8.24199 15.7315 8.01532 15.8333 7.77729 15.8333C7.53926 15.8333 7.31259 15.7315 7.15445 15.5536L3.26356 12.0098C2.95779 11.6658 2.98878 11.1391 3.33276 10.8333C3.67675 10.5275 4.20348 10.5585 4.50924 10.9025L7.77729 13.7456L16.0433 4.44633C16.3491 4.10235 16.8758 4.07136 17.2198 4.37713Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.a8fe84e1a250481b0c5834a8ee5652e3.svg";
export { ForwardRef as ReactComponent };